module.exports = __webpack_public_path__ + "img/mobile2.a1a3417a.png";